import React, {useMemo} from 'react';
import * as dateFns from 'date-fns';
import type {TdProps} from '../core/Td';
import TextCell from '@components/Table/cells/TextCell';
import {useLocalizedFormat} from '@deezer/next/contexts/localization';

type DateCellProps = {
	date: Date | undefined;
	format?: string;
} & TdProps;

const DateCell = ({date, format = 'P', ...rest}: DateCellProps) => {
	const {dateLocale} = useLocalizedFormat();

	const content = useMemo(() => {
		if (!date) return '-';

		try {
			return dateFns.format(date, format, {locale: dateLocale});
		} catch {
			return date.toLocaleDateString();
		}
	}, [date, format, dateLocale]);

	return <TextCell value={content} {...rest} />;
};

export default DateCell;
